const getPageInstanceId = page => page?.data?.[0]?.idinstancia

export default getPageInstanceId